<template>
    <Dialog v-model:visible="modalVisible" header="Subscription Required" @click.stop
        @close="userStore.toggleSubscriptionModal" :modal="true" class="center-dialog">
        <p>You need an active subscription to perform this action.</p>
        <div class="button-container">
            <Button raised label="primary" @click="redirectToCheckout">Start your free trial!</Button>
        </div>
    </Dialog>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/stores/user';

const userStore = useUserStore();
const router = useRouter();

// Computed property for two-way binding with the Dialog
const modalVisible = computed({
  get: () => userStore.showSubscriptionModal,
  set: (value) => {
    userStore.showSubscriptionModal = value;
  },
});

const redirectToCheckout = () => {
    userStore.showSubscriptionModal = false;
    router.push({ name: 'checkout' });
};
</script>

<style scoped>
.center-dialog {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.button-container {
    margin-top: 10px;
    display: flex;
    justify-content: center;
    width: 100%;
}
</style>